<div class="wrapper">
  <div class="fadeMe" *ngIf="showOverlay" (click)="showOverlay = !showOverlay; datepicker.toggle()"></div>
  <div class="content-wrapper">
    <div class="br-section-wrapper">
      <!-- <div class="header_frm">
          <h2>Dashboard</h2>
        </div> -->
      <div class="alertFont pull-right">* Loads will be autoRefreshed every 5 minutes</div>
      <div [ngStyle]="{'max-height.px': screenHeight}" style="overflow-x: hidden; min-height: 300px">
        <div class="row form-group">
          <div class="form-inline text-center" style="margin-left: 27px;">
            <div class="form-group hidden">
              <div class="input-group">
                <input name="datepicker" class="form-control" style="display: none;" ngbDatepicker
                  #datepicker="ngbDatepicker" [autoClose]="false"
                  (dateSelect)="onDateSelection($event); closeDatePicker && datepicker.toggle()" [displayMonths]="2"
                  [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate">
                <ng-template #t let-date let-focused="focused">
                  <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null">
                    {{ date.day }}
                  </span>
                </ng-template>
              </div>
            </div>
            <div class="form-group">
              <div>
                <button class="btn height-27" style="background-color: #7cacd7;
                color: #fff;
                margin-right: 1rem;"
                (click)="resetFilter(true)">Today</button>
              </div>
              <div class="input-group pointer" (click)="showOverlay = !showOverlay; datepicker.toggle()">
                <label>From : &nbsp;</label>
                <input disabled #dpFromDate class="form-control height-27" placeholder="dd-MM-yy"
                  style="width: 97px; color: black; cursor: pointer"
                  (click)="showOverlay = !showOverlay; datepicker.toggle()" name="dpFromDate"
                  [value]="formatDateForDisplay(fromDate)"
                  (input)="fromDate = validateInput(fromDate, dpFromDate.value);">

                <div class="input-group-append">
                  <button class="btn btn-outline-secondary calendar height-27" type="button">
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group ml-2">
              <div class="input-group pointer" (click)="showOverlay = !showOverlay; datepicker.toggle()">
                <label>To : &nbsp;</label>
                <input #dpToDate disabled class="form-control height-27 pointer" placeholder="yyyy-mm-dd"
                  style="width: 97px; color: black" name="dpToDate" [value]="formatDateForDisplay(toDate)"
                  (change)="datepicker.toggle()" (input)="toDate = validateInput(toDate, dpToDate.value);">
                  <!-- <div class="input-group-append">
                  <button class="btn btn-outline-secondary calendar height-27"
                    type="button" (click)="datepicker.toggle()">
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                  </button>
                </div> -->
              </div>
            </div>

            <div class="form-group" style="margin-left: 10px;">
              <button class="btn height-27" style="background-color: #7cacd7;color: #fff;"
                (click)="getBillOfLaddings(false)">Get Data</button>
            </div>


            <div class="form-group" style="margin-left: 10px;">
              <input type="text" class="form-control height-27" style="width: 97px" placeholder="Search.."
                [(ngModel)]="filterQuery" (keyup.enter)="page = 1; changeBackendPagination(page, size, false, true)" />
              <span style="padding: 7px;
                margin-left: -3px;
                height: 28px !important;
                border-radius: 3px;
                cursor: pointer;
                color: #fff;
                background-color: #7cacd7;" (click)="page = 1; changeBackendPagination(page, size, false, true)"> <i
                  class="fa fa-search" aria-hidden="true"></i></span>
            </div>

            <div class="form-group" style="margin-left: 10px;">
              <select class="form-control custom-dropdowns" [(ngModel)]="noOfRecord"
                (change)="getBillOfLaddings(false);" style="height: 27px !important;">
                <option [ngValue]="">Rows</option>
                <option [ngValue]="5">5</option>
                <option [ngValue]="15">15</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
                <option [ngValue]="150">150</option>
                <option [ngValue]="300">200</option>
              </select>
            </div>

            <div class="form-group" style="margin-left: 10px;">
              <button class="btn height-27" (click)="resetFilter()" style="background-color: #67cd5b;color: #fff;">
                <i class="fa fa-refresh"></i>
              </button>
            </div>

            <div class="form-group" style="margin-left: 10px; position: relative;">
              <button class="btn height-27" style="background-color: #7cacd7;color: #fff;"
                (click)="getBillOfLaddings(true)">
                <i class="fas fa-download" style="color: white !important"></i>
              </button>
              <div class="total-count">{{billOfLaddingResponse?.totalNoOfRecords}}</div>
            </div>

            <div class="form-group" style="margin-left: 10px;">
              <button class="btn height-27" style="background-color: #7cacd7;color: #fff;"
                (click)="hideOrShow = !hideOrShow">
                <i class="fa fa-calculator" data-toggle="tooltip" title="Toggle totals"></i>
                <!-- {{hideOrShow ? 'Hide':'Show'}} Total -->
              </button>
            </div>

            <div class="form-group" style="margin-left: 10px; margin-top: 16px;">
              <nav class="" aria-label="Page navigation example text-center">
                <div class="">
                  <ul class="pagination">
                    <li class="page-item">
                      <a href="javascript:void(0)" class="page-link left-traverse" [class.disabled]="page<=1"
                        (click)="page>1 ? changeBackendPagination(page>1?page-1:1, size): null">
                        <i class="fa fa-angle-double-left"></i> Previous</a>
                    </li>
                    <li class="page-item"><a class="page-link" href="javascript:void(0)" style="height: 28px;
                            background-color: #7cacd7;">
                        <p style="margin-top: 0px;">
                          [ <input type="text" (change)="changeBackendPagination(page, size)" style="width: 20px; width: 20px;
                              height: 17px;" [(ngModel)]="page"> / {{billOfLaddingResponse?.totalNoOfPages}} ]
                        </p>
                      </a></li>
                    <li class="page-item"><a class="page-link right-traverse" href="javascript:void(0)"
                        (click)="page < billOfLaddingResponse?.totalNoOfPages && changeBackendPagination(+page+1, size)">Next
                        <i class="fa fa-angle-double-right"></i>
                      </a></li>
                  </ul>
                </div>


              </nav>

              <div class="form-group" style="margin-left: 10px; margin-top: -17px;"> 
                  <button class="btn height-27" style="background-color: #7cacd7;color: #fff;"
                  [disabled]="!availableBolImagesList?.length"
                      (click)="clickToDownloadBolImagesList()">
                      <i class="fa fa-spinner fa-spin" *ngIf="!bOLImagesDownloadComplete" style="color: white !important"></i>
                      <i class="fas fa-download" style="color: white !important" *ngIf="availableBolImagesList?.length"></i>
                      <span *ngIf="bOLImagesDownloadComplete && availableBolImagesList?.length"> Download ({{selectedBolImagesList?.length +"/"+ availableBolImagesList?.length}}) BOL Images </span>
                      <span *ngIf="bOLImagesDownloadComplete && !availableBolImagesList?.length"> No BOL Images Available </span>
                      <span *ngIf="!bOLImagesDownloadComplete || !availableBolImagesList?.length"> Fetching Images, please wait </span>
                  </button>
              </div>

              <div class="form-group" style="margin-left: 10px; margin-top: -15px" *ngIf="shouldDisplayLiteNavigator">
                <button class="btn height-27" style="background-color: #7cacd7;color: #fff;" (click)="gotoLite()">
                  <i class="fa fa-phone"></i> Lite
                  <!-- {{hideOrShow ? 'Hide':'Show'}} Total -->
                </button>
              </div>

            </div>

          </div>

          <!-- <hr/>
            <pre>From date model: {{ fromDate | json }}</pre>
            <pre>To date model: {{ toDate | json }}</pre> -->
        </div>

        <div style="margin-top: -20px;">
          <div id="table-wrapper">
            <div id="table-scroll" style="min-height: 300px;">
              <table *ngIf="billOfLaddingResponse?.billofladings && billOfLaddingResponse?.billofladings?.length > 0"
                id=" " class="table table-insurance-inner " style="font-size: 11px !important;">
                <thead>

                  <tr style="background-color: rgb(178, 173, 173);">
                    <th class="wd-15p th-pd line-height-27" style="padding-left: 20px !important">
                      <div class="plain-text-div">
                        ID <i class="fa icon-for-plain-text"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.idStatus == 'norm' || sortingCurrentStatus.idStatus == 'NA', 
                        'fa-sort-asc': sortingCurrentStatus.idStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.idStatus == 'desc'}"
                          (click)="insertSortingObject('billofladingid')"></i>
                      </div>
                    </th>
                    <th class="wd-15p th-pd text-left" style="width: 6%;">
                      <div class="plain-text-div">
                        Order No.
                        <i class="fa fa-sort"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.orderNoStatus == 'norm' || sortingCurrentStatus.orderNoStatus == 'NA', 
                        'fa-sort-asc': sortingCurrentStatus.orderNoStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.orderNoStatus == 'desc'}"
                          (click)="insertSortingObject('orderno')"></i>
                      </div>
                    </th>



                    <th class="wd-15p th-pd" *ngIf="shouldShowCarrierSelection(user)" style="width: 8%">
                      <i class="fa fa-sort icon"
                        [ngClass]="{'fa-sort': sortingCurrentStatus.tenantStatus == 'norm' || sortingCurrentStatus.tenantStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.tenantStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.tenantStatus == 'desc'}"
                        (click)="insertSortingObject('tenant')"></i>
                      <select class="form-control input-sm custom-dropdowns selector" [(ngModel)]="carrierFilter"
                        (change)="changeBackendPagination(0, noOfRecord, false, true);">
                        <option [ngValue]="null">Carrier</option>
                        <option [ngValue]="tenant.tenantId" *ngFor="let tenant of allowedTenants">{{tenant.tenantName}}
                        </option>
                      </select>
                    </th>
                    <th class="wd-15p th-pd" *ngIf="user.user.role.role == 'ROLE_TENANT_ADMIN'" style="width: 8%">
                      <i class="fa fa-sort icon"
                        [ngClass]="{'fa-sort': sortingCurrentStatus.billtypeStatus == 'norm' || sortingCurrentStatus.billtypeStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.billtypeStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.billtypeStatus == 'desc'}"
                        (click)="insertSortingObject('billtype')"></i>
                      <select class="form-control input-sm custom-dropdowns selector" [(ngModel)]="billtypeFilter"
                        (change)="changeBackendPagination(0, noOfRecord, false, true);" (click)="checkBilltypeFiltersAvailability()">
                        <option [ngValue]="null">Customer</option>
                        <option [ngValue]="customer.displayName" *ngFor="let customer of allowedCustomers">
                          {{customer.displayName}}
                        </option>
                      </select>
                    </th>
                    <th class="wd-5p th-pd line-height-27" style="width: 4%">
                      <div class="plain-text-div">
                        <i class="fa fa-sort icon"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.tacStatus == 'norm' || sortingCurrentStatus.tacStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.tacStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.tacStatus == 'desc'}"
                          (click)="insertSortingObject('tac')"></i>
                        <input type="text" placeholder="Site ID" class="site-entry-text" [(ngModel)]="tacFilter"
                          (ngModelChange)="checkSiteIdFilter()" (keyup.enter)="changeBackendPagination(0, noOfRecord, false, true);">
                      </div>
                    </th>
                    <th class="wd-30p th-pd" style="width: 17%;">
                      <i class="fa fa-sort icon" style="z-index: 100; margin-left: 1px;"
                        [ngClass]="{'fa-sort': sortingCurrentStatus.stationStatus == 'norm' || sortingCurrentStatus.stationStatus == 'NA', 
                    'fa-sort-asc': sortingCurrentStatus.stationStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.stationStatus == 'desc'}"
                        (click)="insertSortingObject('station')"></i>
                      <div class="input-container" style="padding-left: 15px">
                        <ng-select [(ngModel)]="selectedDealer" [virtualScroll]="true" class="custom"
                          (ngModelChange)="changeDealerFilter();displayCount();" placeholder="Site"
                          (click)="checkDealerFiltersAvailability()">
                          <ng-option *ngFor="let dealer of dealers; let dealerIndex = index" [value]="dealer">
                            {{dealer.field1}}</ng-option>
                        </ng-select>
                        <!-- <ngx-select-dropdown [config]="dealerFilterConfig"
                          (change)="changeDealerFilter();" [options]="dealers"
                          (click)="checkDealerFiltersAvailability()"
                          [(ngModel)]="selectedDealer" [multiple]="false"></ngx-select-dropdown> -->
                      </div>
                    </th>
                    <th class="wd-5p th-pd line-height-27">
                      <div class="plain-text-div">
                        CITY <i class="fa fa-sort icon-for-plain-text"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.cityStatus == 'norm' || sortingCurrentStatus.cityStatus == 'NA', 
                        'fa-sort-asc': sortingCurrentStatus.cityStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.cityStatus == 'desc'}"
                          (click)="insertSortingObject('city')"></i>
                      </div>
                    </th>

                    <th class="wd-5p th-pd line-height-27" *ngIf="user?.user?.showProductInDashboard">
                      <div class="plain-text-div">
                        PRODUCT
                        <!-- <i class="fa fa-sort icon-for-plain-text"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.cityStatus == 'norm' || sortingCurrentStatus.cityStatus == 'NA', 
                        'fa-sort-asc': sortingCurrentStatus.cityStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.cityStatus == 'desc'}"
                          (click)="insertSortingObject('city')"></i> -->
                      </div>
                    </th>

                    <th class="wd-15p th-pd" style="width: 13%;">
                      <i class="fa fa-sort icon" style="margin-left: -3px;"
                        [ngClass]="{'fa-sort': sortingCurrentStatus.terminalStatus == 'norm' || sortingCurrentStatus.terminalStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.terminalStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.terminalStatus == 'desc'}"
                        (click)="insertSortingObject('terminal')"></i>
                      <div class="input-container" style="padding-left: 15px">
                        <ngx-select-dropdown [config]="terminalFilterConfig"
                          (change)="changeTerminalFilter(selectedTerminal);changeBackendPagination(0, noOfRecord, false, true);"
                          (click)="checkTerminalFiltersAvailability()" [options]="terminals"
                          [(ngModel)]="selectedTerminal" [multiple]="false"></ngx-select-dropdown>
                      </div>
                    </th>
                    <th class="wd-15p th-pd" style="width: 15%;">
                      <i class="fa fa-sort icon" style="margin-left: -3px;"
                        [ngClass]="{'fa-sort': sortingCurrentStatus.supplierStatus == 'norm' || sortingCurrentStatus.supplierStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.supplierStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.supplierStatus == 'desc'}"
                        (click)="insertSortingObject('supplier')"></i>

                      <div class="input-container" style="padding-left: 15px">
                        <ngx-select-dropdown [config]="supplierFilterConfig"
                          (change)="changeSupplierFilter(selectedSupplier);changeBackendPagination(0, noOfRecord, false, true);"
                          (click)="checkSupplierFiltersAvailability()" [options]="suppliers"
                          [(ngModel)]="selectedSupplier" [multiple]="false"></ngx-select-dropdown>
                      </div>
                    </th>
                    <th class="wd-15p th-pd" style="width: 8%">
                      <i class="fa fa-sort icon"
                        [ngClass]="{'fa-sort': sortingCurrentStatus.statusStatus == 'norm' || sortingCurrentStatus.statusStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.statusStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.statusStatus == 'desc'}"
                        (click)="insertSortingObject('status')"></i>
                      <select class="form-control input-sm custom-dropdowns selector" [(ngModel)]="bolStatusFilter"
                        (change)="changeBackendPagination(0, noOfRecord, false, true)">
                        <option [ngValue]="null">Status</option>
                        <option [ngValue]="1">Order Received</option>
                        <option [ngValue]="10">Dispatched</option>
                        <option [ngValue]="12">Enroute to Rack</option>
                        <option [ngValue]="20">At Rack</option>
                        <option [ngValue]="22">Left Rack</option>
                        <option [ngValue]="24">At Location</option>
                        <option [ngValue]="26">Delivered</option>
                        <option [ngValue]="40">Confirmed</option>
                      </select>
                    </th>
                    <th class="wd-15p th-pd line-height-27">
                      <div class="plain-text-div">
                        DATE
                        <i class="fa fa-sort icon-for-plain-text"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.dateStatus == 'norm' || sortingCurrentStatus.dateStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.dateStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.dateStatus == 'desc'}"
                          (click)="insertSortingObject('scheduleDate')"></i>
                      </div>
                    </th>
                    <th class="wd-15p th-pd line-height-27" style="width: 43px">
                      <div class="plain-text-div">
                        ETA
                        <i class="fa fa-sort icon-for-plain-text"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.etaStatus == 'norm' || sortingCurrentStatus.etaStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.etaStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.etaStatus == 'desc'}"
                          (click)="insertSortingObject('eta')"></i>
                      </div>
                      <!-- <div class="moveCalculatedTotalsUp"><b> Load Count: {{billOfLaddingResponse?.totalNoOfRecords}} </b></div> -->
                    </th>
                    <th class="wd-15p th-pd line-height-27"
                      *ngIf="billOfLaddingResponse && billOfLaddingResponse.showLoads">
                      <input type="text" [(ngModel)]="notesFilter" (blur)="getBillOfLaddings(false)"
                        placeholder="Order No. &#xF002;" />
                    </th>
                    <th class="wd-15p th-pd line-height-27" style="width: 59px;">
                      <div class="plain-text-div">
                        BOL#
                        <i class="fa fa-sort icon-for-plain-text"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.bolStatus == 'norm' || sortingCurrentStatus.bolStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.bolStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.bolStatus == 'desc'}"
                          (click)="insertSortingObject('billoflading')"></i>
                      </div>
                    </th>
                    <th class="wd-15p th-pd line-height-27 text-center">
                      <div class="plain-text-div">
                        BOL Sub
                      </div>
                    </th>
                    <th class="wd-15p th-pd line-height-27 text-center" *ngIf="showInvoices">
                      <div class="plain-text-div">
                        INVOICE
                      </div>
                    </th>
                    <th class="wd-15p th-pd line-height-27 text-center">
                      <div class="plain-text-div">
                        BOL
                      </div>
                    </th>
                    
                    <th class="wd-15p th-pd text-left" style="width: 2%;color: #007bff; padding-left: 20px !important">
                        <input type="checkbox" (change)="selectAllBolImages()" *ngIf="availableBolImagesList?.length"
                        [disabled]="!bOLImagesDownloadComplete"
                        [checked]="isAllBolImagesSelected()"/>
                        <i class="fa fa-spinner fa-spin" *ngIf="!bOLImagesDownloadComplete && !availableBolImagesList?.length" style="color: #007bff;"></i>
                    </th>
                    
                    <!-- <th class="wd-15p th-pd line-height-27" *ngIf="showInvoices" style="width: 59px">
                        <div class="plain-text-div">
                          <i class="fa fa-sort icon"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.invoiceStatus == 'norm' || sortingCurrentStatus.invoiceStatus == 'NA', 
                        'fa-sort-asc': sortingCurrentStatus.invoiceStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.invoiceStatus == 'desc'}"
                          (click)="insertSortingObject('invoice')"></i>
                          <input type="text" placeholder="INVOICE" class="site-entry-text" [(ngModel)]="invoiceFilter" 
                          style="width: 64px;"
                          (ngModelChange)="checkSiteIdFilter()"
                          (keyup.enter)="changeBackendPagination(0, noOfRecord);">
                        </div>
                    </th> -->

                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow" style="width: 54px;">
                      <div style="margin-top: -16px"><b>TOTAL </b>
                        <i class="fa fa-sort icon-for-plain-text"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.totalStatus == 'norm' || sortingCurrentStatus.totalStatus == 'NA', 
                    'fa-sort-asc': sortingCurrentStatus.totalStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.totalStatus == 'desc'}"
                          (click)="insertSortingObject('total')"></i>
                      </div>
                      <div class="moveCalculatedTotalsUp "><b> {{allPageTotals | number:'.'}} </b></div>
                    </th>
                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                      <div style="margin-top: -16px"><b>REG </b></div>
                      <div class="moveCalculatedTotalsUp "><b> {{totalRegQuantity | number:'.'}} </b></div>
                    </th>
                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                      <div style="margin-top: -16px"><b>MID </b></div>
                      <div class="moveCalculatedTotalsUp "><b> {{totalMidQuantity | number:'.'}} </b></div>
                    </th>
                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                      <div style="margin-top: -16px"><b>SUP </b></div>
                      <div class="moveCalculatedTotalsUp "><b> {{totalSupQuantity | number:'.'}} </b></div>
                    </th>
                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                      <div style="margin-top: -16px"><b>ULSD </b></div>
                      <div class="moveCalculatedTotalsUp "><b> {{totalUlsdQuantity | number:'.'}} </b></div>
                    </th>
                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                      <div style="margin-top: -16px"><b>OTH </b></div>
                      <div class="moveCalculatedTotalsUp "><b> {{totalOthQuantity | number:'.'}} </b></div>
                    </th>

                  </tr>
                </thead>

                <tbody>
                  <ng-container
                    *ngFor="let item of billOfLaddingResponse && billOfLaddingResponse.billofladings; let parentIndex = index">

                    <div *ngIf="(item.twoTerminalLoad || item.multipleSuppliers); then thenBlock else elseBlock"></div>
                    <ng-template #thenBlock>
                      <tr class="" [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers}"
                        *ngFor="let billofladingdetail  of item && item.billofladingdetails">
                        <td style="color: #007bff; padding-left: 20px !important">
                          <a href="javascript:void(0)"
                            (click)="openModalForDetails(selectionModalForDetails, item)">{{item?.billOfLadingId}}</a>
                        </td>
                        <td style="">
                          <a href="javascript:void(0)"
                            (click)="openModalForDetails(selectionModalForDetails, item)">{{item?.orderNo}}</a>
                        </td>
                        <td *ngIf="shouldShowCarrierSelection(user)">{{item?.tenantName}}</td>
                        <td *ngIf="user.user.role.role == 'ROLE_TENANT_ADMIN'">
                          {{item?.billofladingdetails[0]?.tblcard?.billtype?.displayName}}</td>
                        <td>{{item?.tac}}</td>
                        <td>{{item?.dealer ? item.dealer.dealer: ''}}</td>
                        <td>{{item?.dealer ? item.dealer.city : ''}} {{item.dealer ? item.dealer.state : ''}}</td>
                        <td *ngIf="user?.user?.showProductInDashboard"
                          (click)="openModalForDetails(selectionModalForDetails, item)">
                          <div class="row">
                            <div class="col-1 "> <i class="fa fa-plus product-expander"></i></div>
                            <div class="col-8 product-name"> {{billofladingdetail?.product?.productName}} </div>
                          </div>
                        </td>
                        <td>{{billofladingdetail?.tblcard?.terminal?.terminalName}}</td>
                        <td>
                          {{billofladingdetail?.tblcard? billofladingdetail?.tblcard?.tblloadunder?
                          billofladingdetail?.tblcard?.tblloadunder?.loadUnderName : '':''}}
                        </td>
                        <td>
                          {{item?.bolstatus >= 40 ? 'Confirmed' : item?.bolstatus >= 26 ? 'Delivered' : item?.bolstatus == 1? 'Order Received':
                          bolstatusMap.get(item.bolstatus+'')}}
                        </td>
                        <td>{{item?.scheduleDateFormatted}}</td>
                        <td>{{item?.etaFormatted}}</td>
                        <td *ngIf="item.showNotes">{{item.billofladingnotes?.loadingNotes}}</td>

                        <td
                          class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                          [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                          <div class="row">
                            <div style="margin-left: 16px;">{{item.billOfLading?item.billOfLading:""}} </div>
                          </div>
                        </td>
                        <td *ngIf="!item?.showDetails" class="bol-sub-unselected"><span *ngFor="let detail of item?.billofladingdetails; let detailIndex = index" (click)="item.showDetails = true">
                          {{detail.billofLadingSub}}<span *ngIf="detail.billofLadingSub"><i class="fa fa-caret-down"></i></span>
                        </span></td>
                        <td *ngIf="item?.showDetails"><div class="bol-sub" *ngFor="let detail of item?.billofladingdetails; let detailIndex = index" (click)="item.showDetails = false">
                          {{detail?.product?.displayCode? detail?.product?.displayCode: detail?.product?.productName}} - {{detail.billofLadingSub}}
                        </div></td>
                        <td *ngIf="showInvoices" style="text-align: center"
                          class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                          [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                          <i *ngIf="checkBatchNumberAvailability(item)" style="margin-left: 40%;"
                            (click)="downloadFile(item.batchNumber, item.tenant, true)"
                            class="fa fa-download pointer"></i>
                        </td>
                        <td style="cursor: pointer; text-align: center;"
                          class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                          [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                          <i *ngIf="checkBolImageSentAvailability(item)" (click)="downloadFile(item.billOfLadingId, item.tenant, false)"
                            class="fa fa-download pointer" style="cursor: pointer; margin-left: 40%;"></i>
                        </td>
                        
                        <td style="color: #007bff; padding-left: 20px !important">
                            <input type="checkbox" 
                            *ngIf="(checkBatchNumberAvailability(item) || checkBolImageSentAvailability(item)) && availableBolImagesList?.length" 
                            [disabled]="!bOLImagesDownloadComplete"
                            [checked]="hasImage(item?.billOfLadingId)"
                            (change)="onBolImageSelectFromGrid(item?.billOfLadingId, $event.target.checked)"/>
                            <i class="fa fa-spinner fa-spin" *ngIf="!bOLImagesDownloadComplete && !availableBolImagesList?.length" style="color: #007bff;"></i>
                        </td>
                        <td *ngIf="hideOrShow">{{item.loadTotal}}</td>
                        <td *ngIf="hideOrShow">
                          {{billofladingdetail?.product? billofladingdetail.product.productId == 1 ?
                          billofladingdetail.quantity: billofladingdetail.reg : ''}}
                        </td>
                        <td *ngIf="hideOrShow">
                          {{billofladingdetail?.product? billofladingdetail.product.productId == 2 ?
                          billofladingdetail.quantity: billofladingdetail.mid : ''}}
                        </td>
                        <td *ngIf="hideOrShow">
                          {{billofladingdetail?.product? billofladingdetail.product.productId == 3 ?
                          billofladingdetail.quantity: billofladingdetail.sup : ''}}
                        </td>
                        <td *ngIf="hideOrShow">
                          {{billofladingdetail?.product? billofladingdetail.product.productId == 4 ?
                          billofladingdetail.quantity: billofladingdetail.ulsd : ''}}
                        </td>
                        <td *ngIf="hideOrShow">
                          {{billofladingdetail?.product? billofladingdetail.product.productId > 4 ?
                          billofladingdetail.quantity: billofladingdetail.oth : ''}}
                        </td>

                      </tr>
                    </ng-template>
                    <ng-template #elseBlock>
                      <tr class=""
                        *ngFor="let billofladingdetail  of converToArray(item.billofladingdetails[0], parentIndex)">
                        <td style="color: #007bff; padding-left: 20px !important">
                          <a href="javascript:void(0)"
                            (click)="openModalForDetails(selectionModalForDetails, item)">{{item?.billOfLadingId}}</a>
                        </td>
                        <td style="">
                          <a href="javascript:void(0)"
                            (click)="openModalForDetails(selectionModalForDetails, item)">{{item?.orderNo}}</a>
                        </td>
                        <td *ngIf="shouldShowCarrierSelection(user)">{{item?.tenantName}}</td>
                        <td *ngIf="user.user.role.role == 'ROLE_TENANT_ADMIN'">
                          {{item?.billofladingdetails[0]?.tblcard?.billtype?.displayName}}</td>
                        <td>{{item?.tac}}</td>
                        <td>{{item?.dealer ? item.dealer.dealer: ''}}</td>
                        <td>{{item?.dealer ? item.dealer.city : ''}} {{item.dealer ? item.dealer.state : ''}}</td>
                        <td *ngIf="user?.user?.showProductInDashboard"
                          (click)="openModalForDetails(selectionModalForDetails, item)">
                          <div class="row">
                            <div class="col-1"> <i class="fa fa-plus product-expander"></i></div>
                            <div class="col-8 product-name"> {{billofladingdetail?.product?.productName}} </div>
                          </div>
                        </td>
                        <td>{{billofladingdetail?.tblcard?.terminal?.terminalName}}</td>
                        <td>
                          {{billofladingdetail?.tblcard? billofladingdetail?.tblcard?.tblloadunder ?
                          billofladingdetail?.tblcard?.tblloadunder?.loadUnderName : '':''}}
                        </td>
                        <td>
                          {{item?.bolstatus >= 40 ? 'Confirmed' : item?.bolstatus >= 26 ? 'Delivered' : item?.bolstatus == 1? 'Order Received':
                          bolstatusMap.get(item.bolstatus+'')}}
                        </td>
                        <td>{{item?.scheduleDateFormatted}}</td>
                        <td>{{item?.etaFormatted}}</td>
                        <td *ngIf="item.showNotes">{{item.billofladingnotes?.loadingNotes}}</td>

                        <td
                          class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                          [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                          <div class="row">
                            <div style="margin-left: 16px;">{{item.billOfLading?item.billOfLading:""}} </div>
                          </div>
                        </td>
                        <td *ngIf="!item?.showDetails" class="bol-sub-unselected"><span *ngFor="let detail of item?.billofladingdetails; let detailIndex = index" (click)="item.showDetails = true">
                          {{detail.billofLadingSub}}<span *ngIf="detail.billofLadingSub"><i class="fa fa-caret-down"></i></span>
                        </span></td>
                        <td *ngIf="item?.showDetails"><div class="bol-sub" *ngFor="let detail of item?.billofladingdetails; let detailIndex = index" (click)="item.showDetails = false">
                          {{detail?.product?.displayCode? detail?.product?.displayCode: detail?.product?.productName}} - {{detail.billofLadingSub}}
                        </div></td>
                        <td *ngIf="showInvoices" style="text-align: center">
                          <!-- *ngIf="item.batchNumber && item.batchNumber != 0" -->
                          <i class="fa fa-download pointer" *ngIf="checkBatchNumberAvailability(item)"
                            style="cursor: pointer; margin-left: 40%; color: rgb(18, 92, 177)"
                            (click)="downloadFile(item.batchNumber, item.tenant, true)">
                          </i>
                        </td>
                        <td style="cursor: pointer;"
                          class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                          [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                          <i *ngIf="checkBolImageSentAvailability(item)" (click)="downloadFile(item.billOfLadingId, item.tenant, false)"
                            class="fa fa-download pointer" style="cursor: pointer; margin-left: 40%"></i>
                        </td>
                        <td style="color: #007bff; padding-left: 20px !important">
                            <input type="checkbox" [checked]="hasImage(item?.billOfLadingId)"
                            *ngIf="(checkBatchNumberAvailability(item) || checkBolImageSentAvailability(item)) && availableBolImagesList?.length" 
                            [disabled]="!bOLImagesDownloadComplete"
                            (change)="onBolImageSelectFromGrid(item?.billOfLadingId, $event.target.checked)"/>
                            <i class="fa fa-spinner fa-spin" *ngIf="!bOLImagesDownloadComplete && !availableBolImagesList?.length" style="color: #007bff;"></i>
                        </td>

                        <td *ngIf="hideOrShow">{{item.loadTotal}}</td>
                        <td *ngIf="hideOrShow">{{billofladingdetail.reg}}</td>
                        <td *ngIf="hideOrShow">{{billofladingdetail.mid}}</td>
                        <td *ngIf="hideOrShow">{{billofladingdetail.sup}}</td>
                        <td *ngIf="hideOrShow">{{billofladingdetail.ulsd}}</td>
                        <td *ngIf="hideOrShow">{{billofladingdetail.oth}}</td>

                      </tr>
                    </ng-template>
                  </ng-container>
                </tbody>
              </table>

              <div class="text-center bold" style="margin-top: 80px"
                *ngIf="!billOfLaddingResponse?.billofladings || billOfLaddingResponse?.billofladings?.length <= 0">
                ** No Records Found
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row align-items-center">
        <div class="col-md-8 align-self-center form-group " style="margin-left: 43%; margin-top: 16px;">
          <nav class="" aria-label="Page navigation example text-center">
            <div class="text-center">
              <ul class="pagination">
                <li class="page-item">
                  <a href="javascript:void(0)" class="page-link left-traverse" [class.disabled]="page<=1"
                    (click)="page>1 ? changeBackendPagination(page>1?page-1:1, size): null">
                    <i class="fa fa-angle-double-left"></i> Previous</a>
                </li>
                <li class="page-item"><a class="page-link" href="javascript:void(0)" style="height: 28px; 
                        background-color: #7cacd7;">
                    <p style="margin-top: 0px;">
                      [ <input type="text" (change)="changeBackendPagination(page, size)" style="width: 20px"
                        [(ngModel)]="page"> / {{billOfLaddingResponse?.totalNoOfPages}} ]
                    </p>
                  </a></li>
                <li class="page-item"><a class="page-link right-traverse" href="javascript:void(0)"
                    (click)="page < billOfLaddingResponse?.totalNoOfPages && changeBackendPagination(+page+1, size)">Next
                    <i class="fa fa-angle-double-right"></i>
                  </a></li>
              </ul>
            </div>
          </nav>
        </div>
      </div>

      <!-- Button trigger modal -->
      <button type="button" style="display: none;" #openModal class="btn btn-primary" data-toggle="modal"
        data-target="#errorModal" data-backdrop="false">
        Launch demo modal
      </button>

      <!-- Modal -->
      <div class="modal fade" id="errorModal" tabindex="-1" role="dialog" data-backdrop="false"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Download</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <img *ngIf="!error" src="./assets/images/download.gif" />
              <img *ngIf="error" src="./assets/images/warning-1.gif" />
              {{errorMsg}}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<!-- modal -->
<ng-template #selectionModalForDetails let-c="close" let-d="dismiss">
  <div class="modal-header" style="background-color: #4c6e9e; color: #ffffff;">
    <h5 class="modal-title" style="font-size: 15px;">Load Details [ {{selectedItem?.billOfLadingId}} ]</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true" style="color: white">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-md-4 loadAddressText">
          <div>{{selectedItem ? selectedItem?.billofladingdetails[0]?.tblcard?.billtype?.displayName : ''}}</div>
          <div>{{selectedItem ? selectedItem?.dealer?.dealer: ''}}</div>
          <div>{{selectedItem ? selectedItem?.dealer?.address:''}}</div>
          <div>{{selectedItem ? selectedItem?.dealer?.city: ''}} {{selectedItem ? selectedItem?.dealer?.state: ''}}
          </div>
          <div>{{selectedItem?selectedItem?.dealer?.address2:''}} </div>
          <div>{{selectedItem?selectedItem?.dealer?.telephone1:''}}</div>
          <div><b>Truck:</b> {{selectedRouteSheet?.truckNumber}}</div>
          <div><b>Trailer:</b> {{selectedRouteSheet?.trailerNumber}}</div>

          <div class="bol-info">
            <b>PO:</b> {{selectedItem?.secondOrderNo}}<br>
            <b>Loading BOL:</b> {{selectedItem?.billOfLading}}<br>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-12">
              <b>At Rack :</b> {{selectedItem?.arrivedAtRackTime | date: 'MM/dd/yy HH:mm'}}
            </div>
            <div class="col-12">
              <b>Left Rack : </b> {{selectedItem?.leftRackTime | date: 'MM/dd/yy HH:mm'}}
            </div>
            <div class="col-12">
              <b>At Location </b>: {{selectedItem?.arrivedAtCustomerTime | date: 'MM/dd/yy HH:mm'}}
            </div>
            <div class="col-12">
              <b>Left Location </b>: {{selectedItem?.finalizedDeliveryTime | date: 'MM/dd/yy HH:mm'}}
            </div>

            <div class="deliver-when col-12">
              <b>Delivery Window:</b> {{selectedItem?.deliverwhen}}
            </div>
          </div>
        </div>
        <div class="col-md-2 text-center">
          Status
          <div class="col-12" style="font-size: 13px;">
            {{selectedItem?.bolstatus >= 40 ? 'Confirmed' : selectedItem?.bolstatus >= 26 ? 'Delivered' : selectedItem?.bolstatus == 1? 'Order Received':
            bolstatusMap.get(selectedItem.bolstatus+'')}}
          </div>
        </div>

        <div class="col-md-2 text-center">
          <button class="button btn-success" *ngFor="let pdf of bolImages" (click)="downloadPdf(pdf)"
            style="     background-color: #567db3;
            border-color: #89bfef;
            margin-left: 29%;
            width: 86%;
            border-radius: 6px;
            height: 29px;">
            <i class="fa fa-download pointer" style="cursor: pointer; color: white !important"></i> {{selectedItem.billOfLadingId}}
          </button>
          <button class="button btn-success" style=" width: 60px; background-color: #567db3; border-color: #89bfef;"
            (click)="downloadFile(selectedItem.billOfLadingId,selectedItem.tenant,false)">
            <i class="fa fa-download pointer" style="cursor: pointer; color: white !important"></i>
          </button>
        </div>

        <div class="col-12">
          <app-upload *ngIf="canUploadFiles" [selectedItem]="selectedItem"></app-upload>
          <button class="button btn-success" style="background-color: #1dd426;
          border-color: #89bfef; margin-left: 75%;
          width: 16%; border-radius: 6px; height: 42px; position: absolute; margin-top: -84px; font-size: 15px;"
            *ngIf="checkEditOption(user)"
            (click)="c('Close click'); openEditModal(editModalForDetails, selectedItem); ">
            <i class="fa fa-pencil pointer" style="cursor: pointer; color: white !important"></i> Edit
          </button>
        </div>
      </div>

    </div>

    <hr>

    <table class="table table-striped" style="font-size: 12px;font-size: 11px;
    padding: 83px;
    margin-top: 8px;
    margin-left: -4px;">
      <thead style="background-color: #9a9a9a" class="text-center">
        <tr>
          <th>
            <b>Terminal</b>
          </th>
          <th>
            <b>Product</b>
          </th>
          <th>
            <b>Supplier</b>
          </th>
          <th>
            <b>Gal Ordered</b>
          </th>
          <th>
            <b>Gal Delivered</b>
          </th>
          <th>
            <b>Gross</b>
          </th>
          <th>
            <b>Net</b>
          </th>
          <th>
            <b>Loading BOL</b>
          </th>
        </tr>
      </thead>
      <tbody [hidden]="!selectedItem" class="text-center">
        <tr [hidden]="!selectedItem" *ngFor="let item of selectedItem?.billofladingdetails">
          <td [hidden]="!selectedItem">{{item?.tblcard?.terminal?.terminalName}}</td>
          <td [hidden]="!selectedItem">{{item?.product?.productName}}</td>
          <td [hidden]="!selectedItem">{{item?.tblcard?.tblloadunder?.loadUnderName}}</td>
          <td [hidden]="!selectedItem">{{item?.ordered}}</td>
          <td [hidden]="!selectedItem">{{item?.netGallons}}</td>
          <td [hidden]="!selectedItem">{{item.quantity}}</td>
          <td [hidden]="!selectedItem">{{item.netGallons}}</td>
          <td [hidden]="!selectedItem">{{item.billofLadingSub}}</td>
        </tr>
      </tbody>
    </table>
    <br>
    <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
    padding: 83px;
    margin-top: 8px;
    margin-left: -4px;">
      <thead style="background-color: #9a9a9a" class="text-center">
        <tr>
          <td><b>Loading Information</b></td>
          <td><b>Un-Loading Information</b></td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
                        margin-top: 8px;">
              <thead class="text-center">
                <tr>
                  <td><b>Start</b></td>
                  <td><b>Finish</b></td>
                  <td><b>Total (Min)</b></td>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr>
                  <td>{{selectedItem?.arrivedAtRackTime | date: 'MM/dd/yy HH:mm'}}</td>
                  <td>{{selectedItem?.leftRackTime | date: 'MM/dd/yy HH:mm'}}</td>
                  <td>{{selectedItem?.rackTimeDiff | number : '1.0-0'}}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>
            <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
                        margin-top: 8px;">
              <thead class="text-center">
                <tr>
                  <td><b>Start</b></td>
                  <td><b>Finish</b></td>
                  <td><b>Total (Min)</b></td>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr>
                  <td>{{selectedItem?.arrivedAtCustomerTime | date: 'MM/dd/yy HH:mm'}}</td>
                  <td>{{selectedItem?.finalizedDeliveryTime | date: 'MM/dd/yy HH:mm'}}</td>
                  <td>{{selectedItem?.locationTimeDiff | number : '1.0-0'}}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <hr>
    <p>
      <b>Driver Notes: </b> {{selectedItem?.billofladingNotes}}
      
    </p>
    <hr>
    <!-- <div class="row text-center">
      <div class="col-12">
      <b>Captured BOL Images</b><br>
        ** Hover on the images to zoom, click on the images to download
      </div>
      <div class="gallery cf">
        <div *ngFor="let image of bolImages">
            <a href="{{image}}" target="_blank">
              <img src="{{image}}" />
            </a>
        </div>

      </div>
    </div> -->

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary close-modal" (click)="c('Close click')">Close</button>
  </div>
</ng-template>

<ng-template #editModalForDetails let-c="close" let-d="dismiss">
  <div class="modal-header" style="background-color: #4c6e9e; color: #ffffff;">
    <h5 class="modal-title" style="font-size: 15px;">Load Details [ {{selectedItem?.billOfLadingId}} ]</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true" style="color: white">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-md-4 loadAddressText">
          <div>{{selectedItem ? selectedItem?.billofladingdetails[0]?.tblcard?.billtype?.displayName : ''}}</div>
          <div>{{selectedItem ? selectedItem?.dealer?.dealer: ''}}</div>
          <div>{{selectedItem ? selectedItem?.dealer?.address:''}}</div>
          <div>{{selectedItem ? selectedItem?.dealer?.city: ''}} {{selectedItem ? selectedItem?.dealer?.state: ''}}
          </div>
          <div>{{selectedItem?selectedItem?.dealer?.address2:''}} </div>
          <div>{{selectedItem?selectedItem?.dealer?.telephone1:''}}</div>
          <div><b>Truck:</b> {{selectedRouteSheet?.truckNumber}}</div>
          <div><b>Trailer:</b> {{selectedRouteSheet?.trailerNumber}}</div>

          <div class="bol-info">
            <b>PO:</b> {{selectedItem?.secondOrderNo}}<br>
            <b>Loading BOL:</b> {{selectedItem?.billOfLading}}<br>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-12 row">
              <div class="col-4"><b>At Rack :</b></div>
              <div class="col-8 12hr-example">
                <div class="ngx-timepicker-field-example">
                  <ngx-timepicker-field [defaultTime]="convertTime(selectedItem?.arrivedAtRackTime, 'arrivedAtRackTimeTemp')" 
                  [format]="12" [(ngModel)]="selectedItem.arrivedAtRackTimeTemp"></ngx-timepicker-field>
              </div>
              </div>
              
            </div>
            <div class="col-12 row">
              <div class="col-4"><b>Left Rack : </b> </div>
              <div class="col-8 12hr-example">
                <div class="ngx-timepicker-field-example">
                  <ngx-timepicker-field [defaultTime]="convertTime(selectedItem?.leftRackTime, 'leftRackTimeTemp')"
                   [format]="12" [(ngModel)]="selectedItem.leftRackTimeTemp"></ngx-timepicker-field>
              </div>
              </div>
            </div>
            <div class="col-12 row">
              <div class="col-4"><b>At Location </b>: </div>
              <div class="col-8 12hr-example">
                <div class="ngx-timepicker-field-example">
                  <ngx-timepicker-field [defaultTime]="convertTime(selectedItem?.arrivedAtCustomerTime, 'arrivedAtCustomerTimeTemp')"
                  [format]="12" [(ngModel)]="selectedItem.arrivedAtCustomerTimeTemp"></ngx-timepicker-field>
              </div>
              </div>
            </div>
            <div class="col-12 row">
              <div class="col-4"><b>Left Location </b>: </div>
              <div class="col-8 12hr-example">
                <div class="ngx-timepicker-field-example">
                  <ngx-timepicker-field [defaultTime]="convertTime(selectedItem?.finalizedDeliveryTime, 'finalizedDeliveryTimeTemp')"
                  [format]="12" [(ngModel)]="selectedItem.finalizedDeliveryTimeTemp"></ngx-timepicker-field>
              </div>
              </div>
            </div>

            <div class="deliver-when col-12">
              <b>Delivery Window:</b> {{selectedItem?.deliverwhen}}
            </div>
          </div>
        </div>
        <div class="col-md-2 text-center">
          Status
          <div class="col-12" style="font-size: 13px;">
            <b>{{selectedItem?.bolstatus >= 40 ? 'Confirmed' : selectedItem?.bolstatus >= 26 ? 'Delivered' : selectedItem?.bolstatus == 1? 'Order Received':
            bolstatusMap.get(selectedItem.bolstatus+'')}}
            </b>
          </div>
        </div>

       
      </div>

    </div>

    <hr>

    <table class="table table-striped" style="font-size: 12px;font-size: 11px;
    padding: 83px;
    margin-top: 8px;
    margin-left: -4px;">
      <thead style="background-color: #9a9a9a" class="text-center">
        <tr>
          <th>
            <b>Terminal</b>
          </th>
          <th>
            <b>Product</b>
          </th>
          <th>
            <b>Supplier</b>
          </th>
          <th>
            <b>Gal Ordered</b>
          </th>
          <th>
            <b>Gal Delivered</b>
          </th>
          <th>
            <b>Gross</b>
          </th>
          <th>
            <b>Net</b>
          </th>
          <th>
            <b>Loading BOL</b>
          </th>
        </tr>
      </thead>
      <tbody [hidden]="!selectedItem" class="text-center">
        <tr [hidden]="!selectedItem" *ngFor="let item of selectedItem?.billofladingdetails">
          <td [hidden]="!selectedItem">{{item?.tblcard?.terminal?.terminalName}}</td>
          <td [hidden]="!selectedItem">{{item?.product?.productName}}</td>
          <td [hidden]="!selectedItem">{{item?.tblcard?.tblloadunder?.loadUnderName}}</td>
          <td [hidden]="!selectedItem">{{item?.ordered}}</td>
          <td [hidden]="!selectedItem">{{item?.netGallons}}</td>
          <td [hidden]="!selectedItem"><input class="edit-boxes" type="text" [(ngModel)]="item.quantity"></td>
          <td [hidden]="!selectedItem"><input class="edit-boxes" type="text" [(ngModel)]="item.netGallons"></td>
          <td [hidden]="!selectedItem"><input class="edit-boxes" type="text" [(ngModel)]="item.billofLadingSub"></td>
        </tr>
      </tbody>
    </table>
    <br>
    <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
    padding: 83px;
    margin-top: 8px;
    margin-left: -4px;">
      <thead style="background-color: #9a9a9a" class="text-center">
        <tr>
          <td><b>Loading Information</b></td>
          <td><b>Un-Loading Information</b></td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
                        margin-top: 8px;">
              <thead class="text-center">
                <tr>
                  <td><b>Start</b></td>
                  <td><b>Finish</b></td>
                  <td><b>Total (Min)</b></td>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr>
                  <td>{{selectedItem?.arrivedAtRackTime | date: 'MM/dd/yy HH:mm'}}</td>
                  <td>{{selectedItem?.leftRackTime | date: 'MM/dd/yy HH:mm'}}</td>
                  <td>{{selectedItem?.rackTimeDiff | number : '1.0-0'}}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>
            <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
                        margin-top: 8px;">
              <thead class="text-center">
                <tr>
                  <td><b>Start</b></td>
                  <td><b>Finish</b></td>
                  <td><b>Total (Min)</b></td>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr>
                  <td>{{selectedItem?.arrivedAtCustomerTime | date: 'MM/dd/yy HH:mm'}}</td>
                  <td>{{selectedItem?.finalizedDeliveryTime | date: 'MM/dd/yy HH:mm'}}</td>
                  <td>{{selectedItem?.locationTimeDiff | number : '1.0-0'}}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <hr>
    <div class="row">
      <div class="col-12" style="margin-bottom: 8px; margin-left: 10px;"><b>Driver Notes: </b></div>
      <div class="col-12"><textarea cols="100" rows="2" class="note-field" [(ngModel)]="selectedItem.billofladingNotes"> </textarea></div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary close-modal" (click)="saveLoad(); c('Close click')">Save</button>
    <button type="button" class="btn btn-secondary close-modal" (click)="c('Close click')">Close</button>
  </div>
</ng-template>


<div class="dl-overlay" *ngIf="showProgressBar">
    <div class="dl-card">
        <div class="dl-card-header">
            <i class="fas fa-cloud-download-alt dl-icon"></i>
            <span class="dl-title">Downloading files</span>
        </div>
        <div class="dl-progress-track">
            <div class="dl-progress-fill" id="percentBar" style="width:0%"></div>
        </div>
        <div class="dl-meta">
            <span id="download-text" class="dl-status">Preparing your download&hellip;</span>
            <span id="percent" class="dl-percent">0%</span>
        </div>
    </div>
</div>
